import { useContext } from 'react'

import CheckoutContext from '../context/checkout.context'

export function useCheckout() {
  const value = useContext(CheckoutContext)
  return value
}
